export const SHOW_NAVBAR_USER = "nav user: SHOW";
export const HIDE_NAVBAR_USER = "nav user: HIDE"

export function showNavUserAction() {
  return {
    type: SHOW_NAVBAR_USER,
  };
}

export function hideNavUserAction() {
    return {
      type: HIDE_NAVBAR_USER,
    };
  }
